export default function UseCase( { index, title, caption } ) {
    return(
        <div style = { { margin : "16px 0px", paddingTop : "40px", minWidth : "50%" } }>
            <div style = { { fontSize : "var(--font-size-teeny)", padding : "6px 18px", background : "var(--black2)", border : "1px solid var(--black8)", borderRadius : "40px", fontFamily : "var(--font-IBM)", textTransform : "uppercase", fontWeight : "800",
                 marginBottom : "8px"
             } }>
              Use Case { index }
            </div>
            <h2 style = {{ lineHeight : 1, padding : "8px" } }>{ title }</h2>
            { caption && <p className = "caption" style = { { textAlign : "center", maxWidth : "100%" } }>{ caption }</p> }
        </div>
    )
}